export const getFloors = ( floors, floor ) => {
	const floorsArray = Array( 5 );
	const currentIndex = Object.keys( floors ).indexOf( floor );
	let notFound = false;

	floorsArray[2] = floor;

	for ( let i = 1; i < 3; i++ )
	{
		floorsArray[2 - i] = Object.keys( floors )[currentIndex - i];
		floorsArray[2 + i] = Object.keys( floors )[currentIndex + i];

		if ( !Object.keys( floors )[currentIndex - i] )
		{
			notFound = -1;
		}

		if ( !Object.keys( floors )[currentIndex + i] )
		{
			notFound = 1;
		}
	}

	const currentFloors = [];

	floorsArray.forEach( ( it ) => {
		if ( it )
		{
			currentFloors.push( it );
		}
	} );

	if ( notFound )
	{
		for ( let i = currentFloors.length; i < 5; i++ )
		{
			if ( notFound < 0 )
			{
				currentFloors.push( Object.keys( floors )[currentIndex + i] );
			}
			else
			{
				currentFloors.unshift( Object.keys( floors )[currentIndex - i] );
			}
		}
	}

	const availableFloors = [];

	currentFloors.forEach( ( it ) => {
		if ( it )
		{
			availableFloors.push( it );
		}
	} );

	return availableFloors;
};